import { Flex } from "@chakra-ui/layout";
import { PieChart, Pie, Cell } from "recharts";
import colors from "core/resources/theme/colors";
import { Skeleton } from "@chakra-ui/skeleton";

interface GraficoExecucaoOrcamentariaProps {
  previsto?: number;
  realizado?: number;
  loading?: boolean;
}

export default function GraficoExecucaoOrcamentaria({
  loading,
  realizado,
  previsto,
}: GraficoExecucaoOrcamentariaProps) {
  const size = 160;
  return (
    <Flex
      flexDir="column"
      gap={6}
      style={{
        transform: "rotate(-90deg)",
      }}
    >
      {!loading ? (
        <PieChart
          style={{
            background: colors.blue100,
            margin: "auto",
            borderRadius: "50%",
          }}
          width={size}
          height={size}
        >
          <Pie
            isAnimationActive={false}
            dataKey="value"
            data={[
              {
                name: "Previsto",
                value: Math.max((previsto ?? 0) - (realizado ?? 0), 0),
              },
              { name: "Realizado", value: realizado },
            ]}
            innerRadius={40}
            outerRadius={size / 2.3}
            labelLine={false}
          >
            <Cell
              key={`cell-0`}
              fill={colors.accentBlue}
              display={previsto ? undefined : "none"}
            />

            <Cell
              key={`cell-1`}
              fill={colors.orange}
              display={realizado ? undefined : "none"}
            />
          </Pie>
        </PieChart>
      ) : (
        <Skeleton w="160px" h="160px" rounded="full" />
      )}
    </Flex>
  );
}
